import {
  MIXPANEL_EVENTS,
  Notification,
  NOTIFICATION_TYPE,
} from 'vendor-marketplace-shared-library';
import useMixpanel from './useMixpanel';
import { useNavigate } from 'react-router-dom';

export default function useNotificationRouting() {
  const navigate = useNavigate();
  const { mixpanelTrack } = useMixpanel();

  const navigateToWorkOrderDetailsNotificationTypeIds = [
    NOTIFICATION_TYPE.WORK_ORDER_BID_PUBLISHED.id,
    NOTIFICATION_TYPE.WORK_ORDER_CREATED.id,
    NOTIFICATION_TYPE.WORK_ORDER_UPDATED.id,
    NOTIFICATION_TYPE.WORK_ORDER_ASSIGNED.id,
    NOTIFICATION_TYPE.WORK_ORDER_ATTACHMENT_CREATED.id,
    NOTIFICATION_TYPE.WORK_ORDER_ATTACHMENT_DELETED.id,
    NOTIFICATION_TYPE.WORK_ORDER_COMMENT_CREATED.id,
    NOTIFICATION_TYPE.WORK_ORDER_WATCHER_CREATED.id,
    NOTIFICATION_TYPE.WORK_ORDER_WATCHER_DELETED.id,
    NOTIFICATION_TYPE.WORK_ORDER_UNASSIGNED.id,
    NOTIFICATION_TYPE.WORK_ORDER_OVERDUE.id,
  ];

  const navigateToUserSettingsNotificationTypeIds = [
    NOTIFICATION_TYPE.ROLE_UPDATED.id,
    NOTIFICATION_TYPE.CONTACT_METHOD_UPDATED.id,
  ];

  const navigateToCreateWorkOrderNotificationTypeIds = [NOTIFICATION_TYPE.NO_WORK_ORDER_CREATED.id];

  function navigateToNotification(notification: Notification) {
    mixpanelTrack(MIXPANEL_EVENTS.NAVIGATE_TO_NOTIFICATION, {
      notificationId: notification.id,
      notificationType: notification.notificationType?.name,
    });

    if (
      navigateToWorkOrderDetailsNotificationTypeIds.includes(
        Number(notification.notificationType!.id),
      )
    ) {
      const workOrderId = notification.content!.match(/#(\d+)/)?.[1];
      if (!workOrderId) return;

      navigate(`/work-orders/${workOrderId}`);
    }

    if (
      navigateToUserSettingsNotificationTypeIds.includes(Number(notification.notificationType!.id!))
    ) {
      navigate('/settings');
    }

    if (
      navigateToCreateWorkOrderNotificationTypeIds.includes(
        Number(notification.notificationType!.id!),
      )
    ) {
      navigate('/create-work-order');
    }
  }

  return navigateToNotification;
}
